import { useFormContext } from "react-hook-form";
import { PwdReqType } from "../../types/Login";
import { useSubmitState } from "../../hooks/useSubmitState";
import { Link } from "react-router-dom";
import { fetchPostPassword } from "../../fetch/fetch.authentication";
import { ROUTE_LOGIN } from "../../const/routes";
import Input from "../../components/core/Input";
import { ErrorMessage } from "@hookform/error-message";
import { IconMail, IconXxx } from "@tabler/icons-react";
import { TEXT_OTP_RESET_REQUIRED } from "../../const/text.ts";
import { OTP_RESET_VALIDATOR } from "../../const/validators.ts";
import ErrorButton from "../../types/Error/ErrorIcons.tsx";
import PasswordInput from "../../components/auth/input/PasswordInput.tsx";
import EmailInput from "../../components/auth/input/EmailInput.tsx";

const submitSuccess = (
  <>
    <IconMail /> Dein Passwort wurde erfolgreich geändert. Klicke und surf
    weiter.
  </>
);
const EnterOtp = () => {
  const {
    handleSubmit,
    register,
    formState: { errors, touchedFields },
  } = useFormContext<PwdReqType>();
  const submitState = useSubmitState({
    initButtonChild: "Neues Passwort festlegen",
  });

  const onSubmit = async (data: PwdReqType) => {
    submitState.init();
    const res = await fetchPostPassword(data);
    if (!res.ok) {
      submitState.fetchFailed(res.error, <ErrorButton error={res.error} />);
      return;
    }
    submitState.fetchSuccess(submitSuccess);
  };

  return (
    <section className="grid rounded-box bg-base-200 p-3 gap-5">
      <div className="grid p-4 gap-4">
        <h2 className="text-2xl font-bold">Bestätige mit Code</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <EmailInput />
          <Input
            input="input"
            validatorHint={<ErrorMessage errors={errors} name="otp" />}
            icon={<IconXxx />}
            label={"Bestätigungscode"}
            isTouched={!!touchedFields.otp}
            isError={!!errors.otp}
          >
            <input
              type="text"
              autoComplete="one-time-code"
              placeholder={`abcd...16`}
              maxLength={16}
              minLength={16}
              {...register("otp", {
                required: TEXT_OTP_RESET_REQUIRED,
                validate: OTP_RESET_VALIDATOR,
              })}
            />
          </Input>
          <PasswordInput autoComplete={"new-password"} />
          {submitState.submitted ? (
            <Link className={`btn btn-success`} to={ROUTE_LOGIN}>
              {submitState.buttonChild}
            </Link>
          ) : (
            <button
              className={`btn w-full ${errors.password || errors.otp || errors.email ? "btn-disabled" : "btn-accent"}`}
            >
              {submitState.buttonChild}
            </button>
          )}
        </form>
      </div>
    </section>
  );
};
export default EnterOtp;
